import { Children } from 'react';

import Equipment from 'model/Equipment';
import { DEVICE_MODAL_TYPE } from 'types/enumType';
import { convertDeviceTypeToString } from 'util/commonUtil';

type DeviceTableProps = {
  type: DEVICE_MODAL_TYPE;
  list: Equipment[];
  deviceId: number;
  isAdmin: boolean;
  onSelect: (type: DEVICE_MODAL_TYPE, id: number) => void;
  onRegister: (type: DEVICE_MODAL_TYPE) => void;
  onClickDetail: (type: DEVICE_MODAL_TYPE, id: number) => void;
  isAvailableDevice: (type: DEVICE_MODAL_TYPE) => boolean;
};

export default function DeviceTable({
  type,
  list,
  deviceId,
  isAdmin,
  onSelect,
  onRegister,
  onClickDetail,
  isAvailableDevice,
}: DeviceTableProps) {
  return (
    <section>
      <div className={'subtit'}>
        <p>{convertDeviceTypeToString(type)}</p>
        {isAvailableDevice(type) && isAdmin && (
          <button
            className={'orange_white_btn'}
            type={'button'}
            onClick={() => onRegister(type)}
          >
            {'신규 추가'}
          </button>
        )}
      </div>
      <div className={'tbl-wrap'}>
        <table className={'tbl_ht01'}>
          <colgroup>
            <col width={'30%'} />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th>{'코드'}</th>
              <th>{`${convertDeviceTypeToString(type)}명`}</th>
            </tr>
          </thead>
          <tbody>
            {!list || list?.length === 0 ? (
              <tr>
                <td colSpan={2}>{'데이터가 없습니다.'}</td>
              </tr>
            ) : (
              Children.toArray(
                list.map((device) => (
                  <tr
                    className={device.id === deviceId ? 'active' : ''}
                    onClick={() => onSelect(type, device.id)}
                  >
                    <td>{device.code}</td>
                    <td className={'left'}>
                      {device.name}
                      {isAdmin && (
                        <button
                          type={'button'}
                          className={'btn_right'}
                          onClick={(event) => {
                            event.stopPropagation();
                            onClickDetail(type, device.id);
                          }}
                        >
                          {'>'}
                        </button>
                      )}
                    </td>
                  </tr>
                )),
              )
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
